<template>
    <div class="video-page">
        <div ref="$video" class="video-page__video">
            <NuxtPicture
                class="video-page__thumbnail"
                :src="`${config.public.bunnyCDN}/${video.bunny_id}/${video.bunny_thumbnail}`"
                placeholder="/images/og/default.png"
                alt=""
                decoding="async"
            />
            <div class="video-page__video-actions">
                <BaseButton
                    class="video-page__video-lock base-button--content-only"
                    icon-left="lock"
                    tabindex="-1"
                    aria-hidden="true"
                    @click="modalStore.toggleModal(MODAL_LOGIN);"
                >
                    Available for members
                </BaseButton>
                <BaseButton
                    class="video-page__video-access"
                    icon-left="play"
                    tabindex="-1"
                    @click="modalStore.toggleModal(MODAL_LOGIN);"
                >
                    Get free access
                </BaseButton>
            </div>
        </div>

        <div class="video-page__header">
            <div class="video-page__meta">
                <VideoDetails :video="video" />
            </div>
            <VideoActions class="video-page__actions" />
        </div>

        <div class="video-page__body">
            <BaseButton
                class="base-button--content-only"
                icon-left="lock"
                @click="modalStore.toggleModal(MODAL_LOGIN);"
            >
                Log in to see the comments
            </BaseButton>

            <UspSection />
        </div>
    </div>
</template>

<script setup>
import { useModalStore, MODAL_LOGIN } from '~/store/modal';

const modalStore = useModalStore();
const config = useRuntimeConfig();
const route = useRoute();

const { data: videoPreviewResponse } = await useAsyncRestApi(
    `videos/${route.params.slug[0]}`
);

const video = computed(() => {
    return toValue(videoPreviewResponse).data;
});

if (!toValue(videoPreviewResponse)?.data) {
    throw createError({
        statusCode: 404
    });
}

useVideoSeo(video);
</script>

<style lang="less" src="./VideoPage.less" />

<style lang="less" scoped>
.video-page__body > .base-button--content-only {
    color: var(--color-lightest);

    @media @q-md-max {
        margin: 0 auto var(--spacing-md);
    }

    @media @q-md-min {
        margin-bottom: var(--spacing-xl);
        padding-left: 0;
    }
}

.video-page__thumbnail {
    position: absolute;
    width: 100%;
    height: 100%;

    :deep(img) {
        height: 100%;
        width: 100%;
        object-fit: cover;
        background-color: var(--color-primary);
    }

    &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: linear-gradient(180deg, rgba(9, 40, 43, 0.53) 0%, #082528 100%);

    }
}

.video-page__video {
    position: relative;
}

.video-page__video-actions {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: var(--spacing-xs);
    flex-direction: column;

    @media @q-md-min {
        gap: var(--spacing-sm);
        justify-content: center;
    }
}

.video-page__video-lock {
    white-space: nowrap;
    color: var(--color-lightest);

    @media @q-md-max {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.video-page__video-access {
    @media @q-md-max {
        width: 100%;
        justify-content: center;
    }
}

.video-page__body {
    display: block;
}
</style>
